import { render, staticRenderFns } from "./dialog_UpdateRight.vue?vue&type=template&id=baa4993c&scoped=true&"
import script from "./dialog_UpdateRight.vue?vue&type=script&lang=js&"
export * from "./dialog_UpdateRight.vue?vue&type=script&lang=js&"
import style0 from "./dialog_UpdateRight.vue?vue&type=style&index=0&id=baa4993c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "baa4993c",
  null
  
)

export default component.exports